import { render, staticRenderFns } from "./MuestrasTabAnalisisParametros.vue?vue&type=template&id=a706b42a"
import script from "./MuestrasTabAnalisisParametros.vue?vue&type=script&lang=js"
export * from "./MuestrasTabAnalisisParametros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports